import script from "./privateKey.vue?vue&type=script&lang=ts&setup=true"
export * from "./privateKey.vue?vue&type=script&lang=ts&setup=true"

import "./privateKey.vue?vue&type=style&index=0&id=6f2fa818&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f2fa818"]])

export default __exports__